import React, { useEffect, useRef, useState } from "react";

import diretorErikTrovilho from "../../../assets/mp4/diretorErikTrovilho.mp4";
import imgSportNutrition from "../../../assets/png/imgSportNutrition.png";
import imgBodyAction from "../../../assets/png/imgBodyAction.png";
import imgMobly from "../../../assets/png/imgMobly.png";
import imgMonsterEnergy from "../../../assets/png/imgMonsterEnergy.png";
import imgSociro from "../../../assets/png/imgSociro.png";
import imgHighBurgerGta from "../../../assets/png/imgHighBurgerGta.png";
import imgRexona from "../../../assets/png/imgRexona.png";
import imgKing from "../../../assets/png/imgKing.png";
import imgFelipeCamargo from "../../../assets/png/imgFelipeCamargo.png";
import imgOGol from "../../../assets/png/imgOGol.png";
import imgAirmaxDay from "../../../assets/png/imgAirmaxDay.png";
import imgJohnnieWalker from "../../../assets/png/imgJohnnieWalker.png";
import imgSomosInter from "../../../assets/png/imgSomosInter.png";
import "./index.css";
import Header from "../../Header";
import ScrollAnimado from "../../ScrollAnimado";

import ModalVideo from "../../ModalVideo";
import Footer from "../../Footer";

export default function ErikTrovilho() {
  const videoRef = useRef(null);

  const [linkVideo, setLinkVideo] = useState("");

  const vaiAte = () => {
    const divPosition = document.getElementById(
      "projetosErickTrovilho"
    ).offsetTop;
    window.scrollTo({
      top: divPosition,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      vaiAte();
    }, 500);
  }, []);
  return (
    <div style={{ backgroundColor: "#000000" }}>
      <div className="w-100 h-100 position-relative">
        <video autoPlay loop muted className="videoBackground">
          <source src={diretorErikTrovilho} type="video/mp4" />
          Seu navegador não suporta vídeos HTML5.
        </video>
        <Header />
        <div className="tituloErikTrovilho">
          Erik <br />
          Trovilho
        </div>
        <ScrollAnimado />
      </div>
      <ModalVideo linkVideo={linkVideo} setLinkVideo={setLinkVideo} />
      <div className="divCapaProjetos" id="projetosErickTrovilho">
        <div className="row p-0 m-0">
          <div className="col-md-6 p-0  ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1144914091?h=83fc2d4218"
                );
              }}
              className="capaProjeto"
              src={imgOGol}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">
              O Gol
            </div>
          </div>
          <div className="col-md-6 p-0 ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1090115482?h=6c80b503a9"
                );
              }}
              className="capaProjeto"
              src={imgAirmaxDay}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">Airmax day</div>
          </div>
        </div>

        <div className="row p-0 m-0">
          <div className="col-md-6 p-0  ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1113627367?h=d554bc20f2"
                );
              }}
              className="capaProjeto"
              src={imgSomosInter}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">
              Somos Inter
            </div>
          </div>
          <div className="col-md-6 p-0 ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1077944931?h=42be6d6f53"
                );
              }}
              className="capaProjeto"
              src={imgJohnnieWalker}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">
              Johnnie Walker
            </div>
          </div>
        </div>

        <div className="row p-0 m-0">
          <div className="col-md-6 p-0  ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/1031171359?h=8bae5a953d"
                );
              }}
              className="capaProjeto"
              src={imgKing}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">King</div>
          </div>
          <div className="col-md-6 p-0 ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/903101691?h=5e1ac78efc"
                );
              }}
              className="capaProjeto"
              src={imgFelipeCamargo}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">
              Felipe Camargo
            </div>
          </div>
        </div>
        <div className="row p-0 m-0">
          <div className="col-md-6 p-0  ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/903103927?h=8bae5a953d"
                );
              }}
              className="capaProjeto"
              src={imgRexona}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">Rexona</div>
          </div>
          <div className="col-md-6 p-0 ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801311?h=5e1ac78efc"
                );
              }}
              className="capaProjeto"
              src={imgSportNutrition}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">
              Sport Nutrition
            </div>
          </div>
        </div>
        <div className="row p-0 m-0">
          <div className="col-md-6 p-0  ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/797771115?h=875c0628ce"
                );
              }}
              className="capaProjeto"
              src={imgBodyAction}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">Bodycation</div>
          </div>

          <div className="col-md-6 p-0 ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801590?h=2eed9c6f58"
                );
              }}
              className="capaProjeto"
              src={imgMonsterEnergy}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">
              Monster Energy
            </div>
          </div>
        </div>
        <div className="row p-0 m-0">
          <div className="col-md-6 p-0 ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801504?h=d08d1a0f73"
                );
              }}
              className="capaProjeto"
              src={imgSociro}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">
              Sóciro / Unfinished Festival{" "}
            </div>
          </div>
          <div className="col-md-6 p-0 ">
            <img
              onClick={() => {
                setLinkVideo(
                  "https://player.vimeo.com/video/809801384?h=97a89d41a0"
                );
              }}
              className="capaProjeto"
              src={imgHighBurgerGta}
              alt="capa do projeto"
            />
            <div className="tituloCardProjeto d-flex d-md-none">
              High Burger GTA
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center w-100">
        <div style={{ maxWidth: 1000 }}>
          <div className="container">
            <div className="tituloErikTrovilhoDetalhes">Erik Trovilho</div>
          </div>
          <div className="container d-flex justify-content-between flex-column align-items-center">
            <div className="textoErikTrovilhoDetalhes">
              Erik Trovilho, ou “Trovis” é fundador da FILO filmes e iniciou sua
              trajetória como videomaker e editor, registrando atletas e eventos
              esportivos pelo Brasil e pelo mundo.A partir dessas experiências
              descobriu o quão transformador é trabalhar com o audiovisual.
              <br />
              <br />
              Durante seu caminho como diretor, pôde desenvolver projetos como
              clipes, curtas, documentários, e campanhas publicitárias. Sua
              estética segue uma temática documental, trabalhando a partir de
              registros - com pouca interferência nas cenas; a captura de
              momentos únicos imprime em seus filmes um tom de autenticidade que
              só ocorre no acaso.
              <br />
              <br />
              <br />
              <br />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}
